var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSeptum = function SvgSeptum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 28,
    height: 41,
    viewBox: "0 0 0.57 0.83",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2315934142320"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M.16.05c0 .01.02.12.02.15 0 .15.01.05-.1.11C.05.33.04.4.07.42c.04.03.25.16.26.16C.36.58.52.46.52.35.52.28.42.28.38.28.37.24.37.08.35.05",
    stroke: "#000",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M.22.54C.14.63.16.78.35.78.48.79.55.64.44.51",
    stroke: "#000",
    strokeWidth: 0.1,
    strokeMiterlimit: 22.9256
  })))));
};

export default SvgSeptum;